export default "__VITE_ASSET__519907ff__"